<template>
    <v-container fluid style="margin:0;padding:0;" v-for="(item, k) in this.$store.getters.getActiveBiomarker"
        v-bind:key="k">
        <v-row style="margin-top:0;margin:0px;padding:0;">

            <v-col cols="12" md="6" lg="6" xl="6" justify="center" align="center"
                            style="padding-left:30px;">



                <div style="margin-left:20px;text-align:left;">
                    <p class="" style="font-size:14px;margin:0;padding:0;">
                        Pathogenicity Predictions
                    </p>
                </div>
                <div class="content-box-toolbar-div">
                    <v-toolbar class="elevation-0" color="#f5f5f5" style="padding:0;text-align:left;" density="compact">
                        <v-toolbar-title style="font-size:14px;padding:0;margin:0;margin-left:10px;top:0;">
                            Multi-feature
                        </v-toolbar-title>
                    </v-toolbar>
                </div>
                <v-card class="elevation-1 content-box"
                    style="padding-left:20px;padding-right:20px;padding-bottom:20px;">
                    <div class="content-box-header-space"></div>

                    <v-table>
                        <tr>
                            <td style="width:100px;"><span class="content-box-subtitle" style="padding:0;">
                                    REVEL
                                </span></td>
                            <td style="width:15px;">
                                <div>
                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                        id="icon-revel" @click="showTooltip('icon-revel', 'revel')" />
                                    <v-tooltip v-model="show_revel" location="top" style="opacity:1;">
                                        <div>
                                            Ensemble method for predicting the pathogenicity of missense variants based
                                            on individual prediction tools
                                            <a href="https://www.cell.com/ajhg/pdf/S0002-9297(16)30370-6.pdf">
                                                <v-icon icon="mdi-arrow-right-drop-circle-outline" />
                                            </a>
                                            <br />
                                            (0=Benign, 1=Pathogenic)
                                        </div>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td v-if="'dbnsfp' in item">
                                <div style="margin-bottom:10px;" v-if="'dbnsfp' in item">
                                    <v-progress-linear v-model="item.dbnsfp.REVEL_rankscore_percent"
                                        :color="getColor(item.dbnsfp.REVEL_rankscore_percent)"
                                        height="25" id="score-bar-revel" class="elevation-0">
                                        {{ item["dbnsfp"]["REVEL_score_aggregated_value"] }}
                                    </v-progress-linear>
                                </div>
                            </td>
                        </tr>
                    </v-table>

                    <v-table>
                        <tr>
                            <td style="width:100px;height:30px;">
                                <span class="content-box-subtitle" style="padding:0;">
                                    MVP
                                </span>
                            </td>
                            <td style="width:20px;">
                                <div>
                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                        id="icon-mvp" @click="showTooltip('icon-mvp', 'mvp')" />
                                    <v-tooltip v-model="show_revel" location="top" style="opacity:1;">
                                        <div>
                                            Deep learning prediction method based on deep residual networks trained on a
                                            variety of features
                                            <a href="https://www.nature.com/articles/s41467-020-20847-0">
                                                <v-icon icon="mdi-arrow-right-drop-circle-outline" />
                                            </a><br />
                                            (0=Benign, 1=Pathogenic)

                                        </div>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td>
                                <div style="margin-bottom:0px;" v-if="'mvp' in item">
                                    <v-progress-linear v-model="item.mvp.score_percent" :color="getColorScaled(item.mvp.Score)"
                                        height="25" id="score-bar-mvp" class="elevation-0">
                                        {{ item["mvp"]["Score"] }}
                                    </v-progress-linear>
                                </div>
                            </td>
                        </tr>
                    </v-table>


                    <div style="height:10px;"></div>
                </v-card>
                <div style="height:0px;"></div>

                <div class="content-box-toolbar-div">
                    <v-toolbar class="elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;"
                        density="compact">
                        <v-toolbar-title style="font-size:14px;padding:0;margin:0;margin-left:10px;">
                            Protein Structure, Amino Acid Characteristics
                        </v-toolbar-title>
                    </v-toolbar>
                </div>
                <v-card class="elevation-1 content-box"
                    style="padding-left:20px;padding-right:20px;padding-bottom:20px;">
                    <div class="content-box-header-space" style="height:35px;"></div>
                    <div>

                        <div v-if="'alphamissense' in item" style="margin-bottom:10px;">
                            <v-table style="">
                                <tr>
                                    <td style="padding-right:15px;width:100px;">
                                        <span class="content-box-subtitle" style="padding:0;">
                                            AlphaMissense
                                        </span>
                                    </td>
                                    <td style="width:15px;">
                                        <!--</v-card-subtitle>-->
                                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                id="icon-ams" @click="showTooltip('icon-ams', 'alphamissense')" />
                                    </td><td>
                                        <v-progress-linear v-model="item.alphamissense.score_percent"
                                            :color="getColorScaled(item.alphamissense.score)" height="25" id="score-bar-alphamissense"
                                            class="elevation-0">
                                            {{ item["alphamissense"]["score_rounded"] }}
                                        </v-progress-linear>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td><td></td>
                                    <td>{{ item["alphamissense"]["alphamissense_class"] }}</td>
                                </tr>
                            </v-table>
                        </div>

                        <div v-if="'dbnsfp' in item">
                            <v-table>
                                <tr>
                                    <td style="width:100px;">
                                        <span class="content-box-subtitle" style="padding:0;">
                                            ESM1b
                                        </span>
                                    </td>
                                    <td style="width:15px;padding-right:10px;">
                                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-lrt"
                                                @click="showTooltip('icon-esm1b', 'esm1b')" />
                                    </td>
                                    <td>
                                        <v-progress-linear v-model="item.dbnsfp['ESM1b_rankscore_percent']"
                                            :color="getColor(item.dbnsfp['ESM1b_rankscore_percent'])" height="25" style="margin-top:5px;"
                                            id="score-bar-mpc" class="elevation-0">
                                            {{ item["dbnsfp"]["ESM1b_score_aggregated_value"] }}
                                        </v-progress-linear>
                                    </td>
                                </tr>
                            </v-table>
                        </div>

                        <div v-if="'dbnsfp' in item">
                            <v-table>
                                <tr>
                                    <td style="width:100px;">
                                        <span class="content-box-subtitle" style="padding:0;">
                                            EVE
                                        </span>
                                    </td>
                                    <td style="width:15px;padding-right:10px;">
                                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-lrt"
                                                @click="showTooltip('icon-eve', 'eve')" />
                                    </td>
                                    <td>
                                        <v-progress-linear v-model="item.dbnsfp['EVE_rankscore_percent']"
                                            :color="getColor(item.dbnsfp['EVE_rankscore_percent'])" height="25" style="margin-top:5px;"
                                            id="score-bar-mpc" class="elevation-0">
                                            {{ item["dbnsfp"]["EVE_score_aggregated_value"] }}
                                        </v-progress-linear>
                                    </td>
                                </tr>
                            </v-table>
                        </div>

                        <div v-if="'dbnsfp' in item">
                            <v-table>
                                <tr>
                                    <td style="width:100px;">
                                        <span class="content-box-subtitle" style="padding:0;">
                                            VARITY_ER_LOO
                                        </span>
                                    </td>
                                    <td style="width:15px;padding-right:5px;">
                                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-lrt"
                                                @click="showTooltip('icon-varityerloo', 'varityerloo')" />
                                    </td>
                                    <td>
                                        <v-progress-linear v-model="item.dbnsfp['VARITY_ER_LOO_rankscore_percent']"
                                            :color="getColor(item.dbnsfp['VARITY_ER_LOO_rankscore_percent'])" height="25" style="margin-top:5px;"
                                            id="score-bar-mpc" class="elevation-0">
                                            {{ item["dbnsfp"]["VARITY_ER_LOO_score_aggregated_value"] }}
                                        </v-progress-linear>
                                    </td>
                                </tr>
                            </v-table>
                        </div>

                        <div v-if="'dbnsfp' in item">
                            <v-table>
                                <tr>
                                    <td style="width:100px;">
                                        <span class="content-box-subtitle" style="padding:0;">
                                            gMVP
                                        </span>
                                    </td>
                                    <td style="width:15px;padding-right:10px;">
                                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-lrt"
                                                @click="showTooltip('icon-gmvp', 'gmvp')" />
                                    </td>
                                    <td>
                                        <v-progress-linear v-model="item.dbnsfp['gMVP_rankscore_percent']"
                                            :color="getColor(item.dbnsfp['gMVP_rankscore_percent'])" height="25" style="margin-top:5px;"
                                            id="score-bar-mpc" class="elevation-0">
                                            {{ item["dbnsfp"]["gMVP_aggregated_value"] }}
                                        </v-progress-linear>
                                    </td>
                                </tr>
                            </v-table>
                        </div>

                        <div v-if="'dbnsfp' in item">
                            <v-table style="">
                                <tr>
                                    <td style="width:100px;">
                                        <span class="content-box-subtitle" style="padding:0;">
                                            MutationAssessor
                                        </span>
                                    </td>
                                    <td style="padding-right:0px;width:15px;">
                                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                id="icon-mut-assessor"
                                                @click="showTooltip('icon-mut-assessor', 'mutation_assessor')" />
                                    </td>
                                    <td v-if="'dbnsfp' in item">
                                        <v-progress-linear v-model="item.dbnsfp.MutationAssessor_rankscore_percent"
                                            :color="getColor(item.dbnsfp.MutationAssessor_rankscore_percent)"
                                            height="25"
                                            id="score-bar-mutationassessor" class="elevation-0">
                                            {{ item["dbnsfp"]["MutationAssessor_score_aggregated_value"] }}
                                        </v-progress-linear>
                                    </td>
                                </tr>
                            </v-table>
                        </div>


                        <div style="height:20px;"></div>
                        <!--<v-table>
                            <tr v-if="'vus_predict' in item">
                                <td>
                                    <span class="content-box-subtitle" style="padding:0;">
                                        Missense 3D
                                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                            id="icon-m3d" @click="showTooltip('icon-m3d', 'missense3d')" />
                                    </span>
                                </td>
                                <td style="width:80%;">{{ item["vus_predict"]["Missense3D"] }}
                                </td>
                            </tr>
                        </v-table>-->

                    </div>
                </v-card>
                <div style="height:0px;"></div>

                            <div class="content-box-toolbar-div">
                            <v-toolbar class="elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;"
                                density="compact">
                                <v-toolbar-title style="font-size:14px;padding:0;margin:0;margin-left:10px;">
                                    Functional Effect Prediction
                                </v-toolbar-title>
                            </v-toolbar>
                            </div>

                            <v-card class="elevation-1" style="margin-top:10px;">
                                <div style="">
                                    <p style="padding-top:25px;">
                                        <v-table style="text-align:left;padding:10px;">
                                            <tr v-if="shouldDisplayOncoKB(item)">
                                                <td>
                                                    Mutation Effect (OncoKB)
                                                </td>
                                                <td>{{ item.oncokb.oncokb.exact_match.mutationEffect.knownEffect }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width:200px;">SIFT</td>
                                                <td>{{ item["dbnsfp"]["SIFT_pred_formatted"] }}</td>
                                            </tr>
                                            <!--<tr v-if="'vus_predict' in item">
                                                <td>FATHMM</td>
                                                <td>{{ item["dbnsfp"]["FATHMM_score"] }}</td>
                                            </tr>-->
                                            <tr v-if="'dbnsfp' in item">
                                                <td>
                                                    <table><tr><td>PolyPhen2 HDIV
                                                    </td><td><v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                    id="icon-pp2-hdiv-p" @click="showTooltip('icon-pp2-hdiv-p', 'polyphen2_hdiv_pred')" />
                                                    </td></tr></table>
                                                </td>
                                                <td>
                                                    {{ item["dbnsfp"]["Polyphen2_HDIV_pred_formatted"] }}
                                                </td>
                                            </tr>
                                            <tr v-if="'dbnsfp' in item">
                                                <td>
                                                    <!--<table><tr><td>

                                                    </td><td>
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                    id="icon-pp2-hdiv-r" @click="showTooltip('icon-pp2-hdiv-r', 'polyphen2_hdiv_rank')" />
                                                    </td></tr></table>-->
                                                </td>
                                                <td v-if="'dbnsfp' in item">
                                                    <v-progress-linear
                                                        v-model="item.dbnsfp.Polyphen2_HDIV_rankscore_percent"
                                                        :color="getColor(item.dbnsfp.Polyphen2_HDIV_rankscore_percent)"
                                                        height="25" class="elevation-0">
                                                        {{ item["dbnsfp"]["Polyphen2_HDIV_score_aggregated_value"] }}
                                                    </v-progress-linear>
                                                </td>
                                            </tr>
                                            <tr v-if="'dbnsfp' in item">
                                                <td>
                                                    <table><tr><td>
                                                        PolyPhen2 HVAR
                                                    </td><td>
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                    id="icon-pp2-hvar-p" @click="showTooltip('icon-pp2-hvar-p', 'polyphen2_hvar_pred')" />
                                                    </td></tr></table>
                                                </td>
                                                <td>{{ item["dbnsfp"]["Polyphen2_HVAR_pred_formatted"] }}</td>
                                            </tr>
                                            <tr v-if="'dbnsfp' in item">
                                                <td>
                                                    <!--<table><tr><td>
                                                    PolyPhen2 HVAR rankscore
                                                    </td><td>
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                    id="icon-pp2-hvar-r" @click="showTooltip('icon-pp2-hvar-r', 'polyphen2_hvar_rank')" />
                                                    </td></tr></table>-->
                                                </td>
                                                <td v-if="'dbnsfp' in item">
                                                    <v-progress-linear
                                                        v-model="item.dbnsfp.Polyphen2_HVAR_rankscore_percent"
                                                        :color="getColor(item.dbnsfp.Polyphen2_HVAR_rankscore_percent)"
                                                        height="25" class="elevation-0">
                                                        {{ item["dbnsfp"]["Polyphen2_HVAR_score_aggregated_value"] }}
                                                    </v-progress-linear>
                                                </td>
                                            </tr>
                                            <tr v-if="'dbnsfp' in item" style="padding-top:5px;">
                                                <td style="padding-top:5px;">CADD
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                    id="icon-cadd" @click="showTooltip('icon-cadd', 'cadd')" />
                                                </td>
                                                <td v-if="'dbnsfp' in item">
                                                    <v-progress-linear
                                                        v-model="item.dbnsfp.CADD_raw_rankscore_percent"
                                                        :color="getColor(item.dbnsfp.CADD_raw_rankscore_percent)"
                                                        height="25" class="elevation-0">
                                                        {{ item["dbnsfp"]["CADD_raw_aggregated_value"] }}
                                                    </v-progress-linear>
                                                </td>
                                            </tr>
                                        </v-table>
                                    </p>
                                </div>
                            </v-card>
                            <div style="height:20px;"></div>

                <!-- VUS-Predict -->
                <div class="content-box-toolbar-div">
                    <v-toolbar class="elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;"
                        density="compact">
                        <v-toolbar-title style="font-size:14px;padding:0;margin:0;margin-left:10px;">
                            Variant of Unknown Significance (VUS)
                        </v-toolbar-title>
                    </v-toolbar>
                </div>
                <v-card class="elevation-0" style="padding-left:20px;padding-right:20px;padding-bottom:20px;">
                    <div class="content-box-header-space"></div>
                    <!--<v-table>
                        <tr>
                            <td style="width:100px;">
                                VUS-Predict
                            </td>
                            <td>
                                <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-vuspredict"
                                    @click="showTooltip('icon-vuspredict', 'vuspredict')" />
                            </td>
                            <td style="padding-right:10px;width:15px;">
                                    <table style="width: 400px; margin-left: 1.5%; margin-right: 1.5%;">
                                        <tr>
                                            <td style="text-align:left;width:40%;padding:0;">
                                                <div style="width:100%;text-align:left;">
                                                    <span v-if="'vus_predict' in item">
                                                        <v-progress-linear style="transform:rotate(180deg) translate(50%);"
                                                            class="elevation-0" v-model="item.vus_predict.score_percent_1of2"
                                                            :color="item.vus_predict.score_color" height="25" :key="revel_key">
                                                        </v-progress-linear>
                                                    </span>
                                                </div>
                                            </td>
                                            <td style="width:40%;">
                                                <div style="width:100%;">
                                                    <span v-if="'vus_predict' in item">
                                                        <v-progress-linear v-model="item.vus_predict.score_percent_2of2"
                                                            :color="item.vus_predict.score_color" height="25" :key="revel_key"
                                                            class="elevation-0">
                                                        </v-progress-linear>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                    <span v-if="'vus_predict' in item">
                                        <div style="margin:0;padding:0;position:absolute;top:0px;text-align:center;left:45%;height:25px;"
                                            id="score-bar-vuspredict">
                                            {{ item["vus_predict"]["Score"] }}
                                        </div>
                                    </span>
                    </td></tr></v-table>-->

                    <v-table style="text-align:left;">
                        <tr v-if="'oncokb' in item">
                            <td>
                                VUS (OncoKB)
                                <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                    id="icon-oncokb" @click="showTooltip('icon-oncokb', 'vus_oncokb')" />
                            </td>
                            <td>
                                <div v-if="'oncokb' in item['oncokb']">
                                    <div v-if="'vus' in item['oncokb']['oncokb']">
                                        {{ item["oncokb"]["oncokb"]["vus"] }}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </v-table>
                </v-card>

            </v-col>
            <v-col cols="12" md="6" lg="6" xl="6" justify="center">
                <div class="content-box-toolbar-div">
                    <v-toolbar class="elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;"
                        density="compact">
                        <v-toolbar-title style="font-size:14px;padding:0;margin:0;margin-left:10px;">
                            Conservation
                        </v-toolbar-title>
                    </v-toolbar>
                </div>
                <v-card class="elevation-1 content-box"
                    style="padding-left:20px;padding-right:20px;padding-bottom:20px;">
                    <div class="content-box-header-space"></div>

                    <v-table><tr><td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            PrimateAI
                        </span>
                    </td>
                    <td style="padding-right:10px;width:15px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-primateai"
                                @click="showTooltip('icon-primateai', 'primateai')" />
                    </td>
                    <td v-if="'dbnsfp' in item">
                        <span v-if="'primateai' in item">
                            <v-progress-linear v-model="item.dbnsfp.PrimateAI_rankscore_percent"
                                :color="getColor(item.dbnsfp.PrimateAI_rankscore_percent)"
                                height="25" id="score-bar-primataai"
                                class="elevation-0">
                                {{ item["primateai"]["Score"] }}
                            </v-progress-linear>
                        </span>
                    </td>
                    </tr>
                    </v-table>
                    <div style="height:0px;"></div>

                    <div v-if="'dbnsfp' in item">
                        <v-table><tr>
                        <td style="width:100px;">
                            <span class="content-box-subtitle" style="padding:0;">
                                GERP++ RS
                            </span>
                        </td>
                        <td style="padding-right:10px;width:15px;">
                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-gerp++"
                                    @click="showTooltip('icon-gerp++', 'gerp++')" />
                        </td>
                        <td v-if="'dbnsfp' in item">
                            <v-progress-linear v-model="item.dbnsfp['GERP++_RS_rankscore_percent']"
                                :color="getColor(item.dbnsfp['GERP++_RS_rankscore_percent'])"
                                height="25"
                                id="score-bar-gerp" class="elevation-0">
                                {{ item["dbnsfp"]["GERP++_RS"] }}
                            </v-progress-linear>
                        </td>
                        </tr>
                        </v-table>
                        <div style="height:0px;"></div>
                    </div>

                    <div v-if="'dbnsfp' in item">
                        <v-table style="text-align:left;">
                            <tr>
                                <td style="width:100px;">
                                    <span class="content-box-subtitle" style="padding:0;">
                                        SIFT score
                                    </span>
                                </td>
                                <td style="width:15px;padding-right:10px;">
                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                            id="icon-sift" @click="showTooltip('icon-sift', 'sift')" />
                                </td>
                                <td v-if="'dbnsfp' in item">
                                    <v-progress-linear v-if="'dbnsfp' in item"
                                        v-model="item.dbnsfp.SIFT_converted_rankscore_percent"
                                        :color="getColor(item.dbnsfp.SIFT_converted_rankscore_percent)" height="25"
                                        class="elevation-0">
                                        {{ item["dbnsfp"]["SIFT_score_aggregated_value"] }}
                                    </v-progress-linear>
                                    <div style="height:10px;"></div>
                                </td>
                            </tr>
                        </v-table>
                    </div>

                    <div v-if="'dbnsfp' in item">
                        <v-table>
                        <tr>
                        <td style="width:100px;">
                            <span class="content-box-subtitle" style="padding:0;">
                                PhastCons 17way Primate
                            </span>
                        </td>
                        <td style="width:15px;padding-right:10px;">
                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-p17"
                                @click="showTooltip('icon-p17', 'phastcons_17way_primate')" />
                        </td>
                        <td>
                            <v-progress-linear v-model="item.dbnsfp.phastCons17way_primate_rankscore_percent"
                                :color="getColor(item.dbnsfp.phastCons17way_primate_rankscore_percent)"
                                height="25"
                                style="margin-top:5px;" id="score-bar-phastcons" class="elevation-0">
                                {{ item["dbnsfp"]["phastCons17way_primate"] }}
                            </v-progress-linear>
                        </td>
                        </tr>
                        </v-table>
                    </div>

                    <div style="height:0;"></div>
                </v-card>
                <div style="height:00px;"></div>
                <div class="content-box-toolbar-div">
                    <v-toolbar class="elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;"
                        density="compact">
                        <v-toolbar-title style="font-size:14px;padding:0;margin:0;margin-left:10px;">
                            Miscellaneous
                        </v-toolbar-title>
                    </v-toolbar>
                </div>
                <v-card class="elevation-1 content-box"
                    style="padding-left:20px;padding-right:20px;padding-bottom:20px;">
                    <div class="content-box-header-space" style="height:35px;"></div>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            FATHMM-MKL
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-fathmm-mkl"
                                @click="showTooltip('icon-fathmm-mkl', 'fathmm')" />
                    </td>
                    <td>
                        <v-progress-linear v-model="item.dbnsfp['fathmm-MKL_coding_rankscore_percent']"
                            :color="getColor(item.dbnsfp['fathmm-MKL_coding_rankscore_percent'])" height="25"
                            style="margin-top:5px;" id="score-bar-fathmm-mkl" class="elevation-0">
                            {{ item["dbnsfp"]["fathmm-MKL_coding_score"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            FATHMM-XF
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-fathmm-xf"
                            @click="showTooltip('icon-fathmm-xf', 'fathmm')" />
                    </td>
                    <td>
                        <v-progress-linear v-model="item.dbnsfp['fathmm-XF_coding_rankscore_percent']"
                            :color="getColor(item.dbnsfp['fathmm-XF_coding_rankscore_percent'])" height="25" style="margin-top:5px;"
                            id="score-bar-fathmm-xf" class="elevation-0">
                            {{ item["dbnsfp"]["fathmm-XF_coding_score"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            LoFTool
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-loftool"
                                @click="showTooltip('icon-loftool', 'loftool')" />
                    </td>
                    <td>
                        <v-progress-linear v-model="item.loftool.score_percent"
                            :color="getColor(item.loftool.Score)" height="25" style="margin-top:5px;"
                            id="score-bar-loftool" class="elevation-0">
                            {{ item["loftool"]["Score_rounded"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            M-CAP
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-m-cap"
                                @click="showTooltip('icon-m-cap', 'm-cap')" />
                    </td>
                    <td v-if="'dbnsfp' in item">
                        <v-progress-linear
                            v-model="item.dbnsfp['M-CAP_rankscore_percent']"
                            :color="getColor(item.dbnsfp['M-CAP_rankscore_percent'])"
                            height="25" style="margin-top:5px;"
                            id="score-bar-mcap" class="elevation-0">
                            {{ item["dbnsfp"]["M-CAP_score"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            MetaLR
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-metalr"
                            @click="showTooltip('icon-metalr', 'metalr')" />
                    </td>
                    <td v-if="'dbnsfp' in item">
                        <v-progress-linear v-model="item.dbnsfp['MetaLR_rankscore_percent']"
                            :color="getColor(item.dbnsfp['MetaLR_rankscore_percent'])"
                            height="25" style="margin-top:5px;"
                            id="score-bar-mcap" class="elevation-0">
                            {{ item["dbnsfp"]["MetaLR_score"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            MetaSVM
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-metasvm"
                            @click="showTooltip('icon-metasvm', 'metasvm')" />
                    </td>
                    <td v-if="'dbnsfp' in item">
                        <v-progress-linear v-model="item.dbnsfp['MetaSVM_rankscore_percent']"
                            :color="getColor(item.dbnsfp.MetaSVM_rankscore_percent)"
                            height="25" style="margin-top:5px;"
                            id="score-bar-mcap" class="elevation-0">
                            {{ item["dbnsfp"]["MetaSVM_score"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            MutationTaster
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-mut-taster"
                            @click="showTooltip('icon-mut-taster', 'mutation_taster')" />
                    </td>
                    <td v-if="'dbnsfp' in item">
                        <v-progress-linear v-model="item.dbnsfp['MutationTaster_converted_rankscore_percent']"
                            :color="getColor(item.dbnsfp['MutationTaster_converted_rankscore_percent'])"
                            height="25"
                            style="margin-top:5px;" id="score-bar-mcap" class="elevation-0">
                            {{ item["dbnsfp"]["MutationTaster_score_aggregated_value"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            PROVEAN
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-provean"
                            @click="showTooltip('icon-provean', 'provean')" />
                    </td>
                    <td v-if="'dbnsfp' in item">
                        <v-progress-linear v-model="item.dbnsfp['PROVEAN_converted_rankscore_percent']"
                            :color="getColor(item.dbnsfp['PROVEAN_converted_rankscore_percent'])"
                            height="25"
                            style="margin-top:5px;" id="score-bar-mcap" class="elevation-0">
                            {{ item["dbnsfp"]["PROVEAN_score_aggregated_value"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                    <td style="width:100px;">
                        <span class="content-box-subtitle" style="padding:0;">
                            MPC
                        </span>
                    </td>
                    <td style="width:15px;padding-right:10px;">
                        <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-mpc"
                            @click="showTooltip('icon-mpc', 'mpc')" />
                    </td>
                    <td v-if="'dbnsfp' in item">
                        <v-progress-linear v-model="item.dbnsfp['MPC_rankscore_percent']"
                            :color="getColor(item.dbnsfp['MPC_rankscore_percent'])"
                            height="25" style="margin-top:5px;"
                            id="score-bar-mpc" class="elevation-0">
                            {{ item["dbnsfp"]["MPC_score_aggregated_value"] }}
                        </v-progress-linear>
                    </td>
                    </tr>
                    </v-table>

                    <v-table>
                    <tr>
                        <td style="width:100px;">
                            <span class="content-box-subtitle" style="padding:0;">
                                LRT
                            </span>
                        </td>
                        <td style="width:15px;padding-right:10px;">
                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)" id="icon-lrt"
                                    @click="showTooltip('icon-lrt', 'lrt')" />
                        </td>
                        <td>
                            <v-progress-linear v-model="item.dbnsfp['LRT_converted_rankscore_percent']"
                                :color="getColor(item.dbnsfp['LRT_converted_rankscore_percent'])" height="25" style="margin-top:5px;"
                                id="score-bar-mpc" class="elevation-0">
                                {{ item["dbnsfp"]["LRT_score_aggregated_value"] }}
                            </v-progress-linear>
                        </td>
                    </tr>
                    </v-table>

                </v-card>


                <div style="height:20px;"></div>

                <div>
                    Other mutations at the same position
                </div>
                <div>
                    <div v-if="'alphamissense' in item" style="margin-bottom:10px;">
                            <v-table style="">
                                <tr v-for="(key) in Object.keys(item['alphamissense']['other_mutations_at_same_position'])">
                                        <td style="padding-right:15px;width:100px;">
                                            <span class="content-box-subtitle" style="padding:0;">
                                                {{ key }}
                                            </span>
                                        </td>
                                        <td style="width:15px;">
                                            <!--</v-card-subtitle>-->
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                    id="icon-ams" @click="showTooltip('icon-ams', 'alphamissense')" />
                                        </td><td>
                                            <v-progress-linear v-model="item.alphamissense.score_percent"
                                                :color="getColorScaled(item.alphamissense.other_mutations_at_same_position[key].score)" height="25" id="score-bar-alphamissense"
                                                class="elevation-0">
                                                {{ item.alphamissense.other_mutations_at_same_position[key].score }}
                                            </v-progress-linear>
                                        </td>
                                </tr>
                                <tr>
                                    <td></td><td></td>
                                    <td>{{ item["alphamissense"]["alphamissense_class"] }}</td>
                                </tr>
                            </v-table>
                        </div>
                </div>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" lg="6" xl="6" justify="center">

            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import useTooltip from '@/methods/tooltip.js';

export default {
    name: 'ScoreBars',
    props: {
    },
    data: function () {
        return {
            item: {},
            revel: this.$store.getters.getAppValue('revel'),
            revel_raw: this.$store.getters.getAppValue('revel-raw'),
            loftool: this.$store.getters.getAppValue('loftool'),
            loftool_raw: this.$store.getters.getAppValue('loftool-raw'),
            vuspredict: this.$store.getters.getAppValue('vuspredict'),
            vuspredict_raw: this.$store.getters.getAppValue('vuspredict-raw'),
            revel_key: 0,
            loftool_key: 0,
            vuspredict_key: 0,
            mvp_key: 0,
            show_revel: false,
            revel_desc: "",
        }
    },
    components: {
    },
    created: async function () {
        this.item = this.$store.getters.getVariants[this.$store.getters.getActiveBiomarker]
    },
    methods: {
        /**
         * Uses the tooltip composable to show a tooltip next to whatever was clicked (in this case v-icons for the pathogenicity scores).
         * @param {string} element_id - ID of the element (HTML)
         * @param {string} tooltip_id - ID of the tooltip in metadata.json
         * @param {string} tooltip_title - Title to show. Defaults to the one set in metadata.json if passed as undefined.
         */
        showTooltip(element_id, tooltip_id, tooltip_title = undefined) {
            useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
        },
        getColor(value) {
            if ((value > 0) && (value < 25)) {
                return "#C0EDA6"
            } else if ((value >= 25) && (value < 50)) {
                return "#FFF7BC"
            } else if ((value >= 50) && (value < 75)) {
                return "#FF8080"
            } else if ((value > 75) && (value <= 100)) {
                return "#FD5D5D"
            }
            return "#e3e3e3"
        },
        getColorScaled(value) {
            if ((value > 0) && (value < 0.25)) {
                return "#C0EDA6"
            } else if ((value >= 0.25) && (value < 0.50)) {
                return "#FFF7BC"
            } else if ((value >= 0.50) && (value < 0.75)) {
                return "#FF8080"
            } else if ((value > 0.75) && (value <= 1.00)) {
                return "#FD5D5D"
            }
            return "#e3e3e3"
        },
        shouldDisplayOncoKB(item) {
            if (item != undefined) {
                if ('oncokb' in item) {
                    if ('oncokb' in item['oncokb']) {
                        if ('exact_match' in item['oncokb']['oncokb']) {
                            if ('mutationEffect' in item['oncokb']['oncokb']['exact_match']) {
                                return true
                            }
                        }
                    }
                }
            }
            return false
        },
    }
}
</script>
<style scoped>
.content-box-subtitle {
    padding-left: 10px;
    width: 100%;
}
</style>